import StringUtils from './StringUtils';

const ANCHOR_ELEMENT_NAME = 'A';
const DEFAULT_PORT = 80;

class URIBuilder {
    constructor(uri = StringUtils.EMPTY) {
        let link = document.createElement(ANCHOR_ELEMENT_NAME);
        link.href = uri;

        this._protocol = link.protocol;
        this._user = link.user;
        this._password = link.password;
        this._hostName = link.hostname;
        this._port = link.port;
        this._path = link.pathname;
        this._params = this._parseParams(link.search);
    }

    _parseParams(paramsString) {
        if (paramsString == null || paramsString.length === 0) {
            return null;
        }

        let params = {};
        
        let paramsStringSegments = paramsString.substr(1).split('&');
        paramsStringSegments.forEach((segment) =>  {
            let key = decodeURIComponent(segment.split('=')[0]);
            let value = decodeURIComponent(segment.split('=')[1]);

            params[key] = value;
        });

        return params;
    }

    get protocol() {
        return this._protocol;
    }

    set protocol(protocol) {
        this._protocol = protocol;
    }

    get user() {
        return this._user;
    }

    set user(user) {
        this._user = user;
    }

    get password() {
        return this._password;
    }

    set password(password) {
        this._password = password;
    }

    get hostName() {
        return this._hostName;
    }

    set hostName(hostName) {
        this._hostName = hostName;
    }

    get port() {
        return this._port;
    }

    set port(port) {
        this._port = port;
    }

    get path() {
        return this._path;
    }

    set path(path) {
        this._path = path;
    }

    get params() {
        return this._params;
    }

    set params(params) {
        this._params = params;
    }

    addParam(name, value) {
        if (this.params == null) {
            this.params = {};
        }

        if (this.params[name] == null) {
            this.params[name] = [];
        }

        this.params[name].push(value);
    }

    toString() {
        let uriString = `${this.protocol}//`;

        if (StringUtils.isNotBlank(this.user)) {
            uriString += `${this.user}:${this.password}@`;
        }

        let port = this.port;
        if (StringUtils.isNotBlank(port)) {
            port = DEFAULT_PORT;
        }

        uriString += `${this.hostName}:${port}${this.path}`;

        if (this.params != null) {
            uriString += '?';
            for (let key in this.params) {
                let values = this.params[key];
                for (let i in values) {
                    uriString += `${encodeURIComponent(key)}=${encodeURIComponent(values[i])}&`;
                }
            }
        }

        return uriString;
    }

}

export default URIBuilder;


// WEBPACK FOOTER //
// ./src/_utils/URIBuilder.js